<template>
	<VDialog class="report-drop-overlay">
		<article class="upload-section">
			<div
				v-if="!isFileLoading"
				class="info-wrap"
			>
				<div class="title">
					Перетащите файл для загрузки сюда
				</div>
				<VIcon
					class="icon"
					material="cloud_upload"
					theme="outlined"
				/>
			</div>
			<div
				v-else
				class="info-wrap"
			>
				<div class="title">
					Файл загружается, подождите, пожалуйста ...
				</div>
				<VIcon
					class="loading-icon icon"
					material="autorenew"
					theme="outlined"
				/>
			</div>
		</article>
	</VDialog>
</template>

<style lang="scss" src="./ReportsDropOverlayDialog.scss"/>

<script lang="ts">
export default defineComponent({
	name: 'ReportsDropOverlayDialog',

	props: {
		isFileLoading: {
			type: Boolean,
			default: false,
		},
	},
});
</script>
